import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';

import AppError from '../../errors/AppError';
import IMessageTemplate from '../../interfaces/iMessageTemplate';
import IMessageType from '../../interfaces/IMessageType';

const useMessageTemplateService = () => {
  const request = useRequest<IMessageTemplate>();
  const requestType = useRequest<IMessageType>();
  const path = 'message-template';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
  ): Promise<IPaginationReturn<IMessageTemplate[]>> => {
    return await request
      .getManyPaginated({
        path: `${path}?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listTypes = async (): Promise<IMessageType[]> => {
    return await requestType
      .getMany({
        path: `${path}/list-types`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listById = async (id: number): Promise<IMessageTemplate> => {
    return await request
      .getOne({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (resource: IMessageTemplate): Promise<IMessageTemplate> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, resource: IMessageTemplate): Promise<IMessageTemplate> => {
    return await request
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, listById, create, update, remove, listTypes };
};

export { useMessageTemplateService };
